import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PackageUtils {
  getHeaderColumn<T>(data: T[]) {
    const firstRecord = { ...data[0] } as object;
    const columnHeading = Object.keys(firstRecord).map((i) => {
      return `${i.toUpperCase()}`;
    });
    return columnHeading;
  }
  getExportData<T extends Record<string, any>>(data: T[]) {
    // Get the ordered keys from the first object
    const keys = Object.keys(data[0] as {});

    // Process each row based on the key order
    return data.map(
      (row) => keys.map((key) => row[key] ?? ''), // Maintain order and handle missing values
    );
  }

  getCSVExportData<T>(eventData: T[], trackingNumber: string) {
    const eventDataWithTrackingNumber = eventData.map((event) => {
      return {
        trackingNumber,
        ...event,
      };
    });
    const uniqueSortedEvents = this.getUniqueSortedEvents(
      eventDataWithTrackingNumber,
    );
    const csvFileData = [
      uniqueSortedEvents.length ? this.getHeaderColumn(uniqueSortedEvents) : [],
      ...(uniqueSortedEvents.length
        ? this.getExportData(uniqueSortedEvents)
        : []),
    ];
    return csvFileData;
  }

  getUniqueSortedEvents(events: any[]): any[] {
    const uniqueMap = new Map<string, any>();

    events.sort(
      (a, b) =>
        new Date(b.dateTimestamp).getTime() -
        new Date(a.dateTimestamp).getTime(),
    );

    events.forEach((event) => {
      const key = `${event.dateTimestamp}__${event.eventDescription}__${event.source}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, event);
      }
    });

    return Array.from(uniqueMap.values());
  }
  getTableHeaderWithData<T>(
    primitiveData: string | T[],
    csvData: string[][],
    trackingNumber: string,
    eventType: string,
  ) {
    return [
      ...(primitiveData.length
        ? [[`${trackingNumber}`, '', '', '', '', '', `${eventType}`]]
        : []),
      ...(primitiveData.length ? csvData : []),
    ];
  }

  normalizeObjectFields<T extends Record<string, any>>(data: T[]): T[] {
    if (!Array.isArray(data) || data.length === 0) return [];

    // Collect all unique keys from all records
    const keys = new Set<string>();
    data.forEach((item) => Object.keys(item).forEach((key) => keys.add(key)));

    // Normalize each record to ensure all keys exist
    return data.map((item) => {
      const newItem = { ...item } as any;
      keys.forEach((key) => {
        if (!(key in newItem) || newItem[key] === null) {
          newItem[key] = '';
        }
      });
      return newItem;
    });
  }
}
